import { DesignPencil } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "shared/components";
import { Box, Flex } from "styled-system/jsx";

export const ListStats = () => {
  const { t } = useTranslation();

  return (
    <Flex flexDir={"column"} gap={"400"}>
      <PageHeader
        title={t("customLists:LIST_DETAILS.TABS.LIST_STATS")}
        description={t("customLists:LIST_DETAILS.PAGE.LIST_STATS.DESCRIPTION")}
        Icon={DesignPencil}
        /* TODO: Add export to CSV button props */
        ctaButtonCopy={t("customLists:LIST_DETAILS.CTA_BUTTONS.EXPORT_TO_CSV")}
        ctaButtonProps={{
          onClick: () => {},
          disabled: false,
        }}
      />
      <Flex flexDir={"column"} gap={"400"}>
        <Box>First Section</Box>
        <Box>Second Section</Box>
      </Flex>
    </Flex>
  );
};
